import React, { Fragment } from 'react';
import { Typo3Image, Typo3Link } from '../../provider/Typo3Provider/types';
import { Card, CardContent, CardFormat, CardImage } from '../Card';
import { FontIconSpan } from '../FontIcon';
import { Column } from '../Grid';
import { TextLink } from '../Link';
import { Paragraph } from '../Paragraph';
import { Title } from '../Title';
import { TypoImage } from '../TypoImage';
import { HtmlContent } from './HtmlContent';

interface TeaserProps {
  teasers: (Typo3Image & Typo3Link)[];
  format: CardFormat;
}

const Teaser = ({ teasers, format }: TeaserProps) => {
  return (
    <Fragment>
      {teasers.map((teaser, index) => {
        const { title, link, description } = teaser;

        const content = (
          <Fragment>
            <CardImage format={format}>
              <TypoImage image={teaser} hideDescription />
            </CardImage>
            <CardContent format={format}>
              {title && (
                <Fragment>
                  <Title.Card>
                    {format === 'circle' ? (
                      <FontIconSpan icon="arrow" arrow="right">
                        <HtmlContent htmlString={title} />
                      </FontIconSpan>
                    ) : (
                      <HtmlContent htmlString={title} />
                    )}
                  </Title.Card>
                </Fragment>
              )}
              {description && (
                <Paragraph>
                  <HtmlContent htmlString={description} />
                </Paragraph>
              )}
            </CardContent>
          </Fragment>
        );

        return (
          <Column key={index} small={12} medium={6} large={12 / teasers.length}>
            <Card format={format}>
              {link ? <TextLink to={link}>{content}</TextLink> : content}
            </Card>
          </Column>
        );
      })}
    </Fragment>
  );
};

export default Teaser;
